<template>
    <XyzTransition appear xyz="fade">
        <div class="bg-white rounded-lg shadow-md p-5 m-2 lg:mx-4">
            <div class="font-medium text-gray-600 text-xl mb-4">
                Destinatario
            </div>
            <div class="flex flex-col h-24">
                <div class="my-1 text-gray-700">Directorio</div>
                <Dropdown
                    v-model="selectedDestination"
                    :options="destinatarios"
                    optionLabel="nombre"
                    optionValue="id"
                    :filter="true"
                    placeholder="Seleccionar de directorio"
                    emptyMessage="Sin destinatarios en directorio"
                    :showClear="true"
                    class="h-[42px] flex items-center"
                    @change="setDestination"
                >
                </Dropdown>
            </div>
            <div class="flex flex-col">
                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="destino_nombre" class="my-1 text-gray-700">
                            Nombre<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="destino_nombre"
                            :class="[
                                't-input',
                                errors?.destino_nombre && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_nombre"
                            placeholder="ej. Romina Campos"
                        />
                        <small
                            v-if="errors?.destino_nombre"
                            id="destino_nombre-help"
                            class="p-error"
                        >
                            {{ errors.destino_nombre[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label
                            for="destino_documento"
                            class="my-1 text-gray-700"
                        >
                            Nro. documento
                        </label>
                        <input
                            type="text"
                            id="destino_documento"
                            :class="[
                                't-input',
                                errors?.destino_documento && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_documento"
                            placeholder="ej. 99999999"
                        />
                        <small
                            v-if="errors?.destino_documento"
                            id="destino_documento-help"
                            class="p-error"
                        >
                            {{ errors.destino_documento[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="destino_email" class="my-1 text-gray-700">
                            Email<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="email"
                            id="destino_email"
                            :class="[
                                't-input',
                                errors?.destino_email && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_email"
                            placeholder="ej. romina.campos75@gmail.com"
                        />
                        <small
                            v-if="errors?.destino_email"
                            id="destino_email-help"
                            class="p-error"
                        >
                            {{ errors.destino_email[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label
                            for="destino_telefono"
                            class="my-1 text-gray-700"
                        >
                            Telefono<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="tel"
                            id="destino_telefono"
                            :class="[
                                't-input',
                                errors?.destino_telefono && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_telefono"
                            placeholder="ej. +54 11 1234-5678"
                        />
                        <small
                            v-if="errors?.destino_telefono"
                            id="destino_telefono-help"
                            class="p-error"
                        >
                            {{ errors.destino_telefono[0] }}
                        </small>
                    </div>
                </div>

                <div class="w-full h-24">
                    <label for="destino_calle" class="my-1 text-gray-700">
                        Calle<span class="text-red-400">*</span>
                    </label>
                    <input
                        type="text"
                        id="destino_calle"
                        :class="[
                            't-input',
                            errors?.destino_calle && 't-input-invalid',
                        ]"
                        v-model="destinatario.destino_calle"
                        placeholder="ej. Av. San Martín"
                    />
                    <small
                        v-if="errors?.destino_calle"
                        id="destino_calle-help"
                        class="p-error"
                    >
                        {{ errors.destino_calle[0] }}
                    </small>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="destino_altura" class="my-1 text-gray-700">
                            Altura<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="number"
                            id="destino_altura"
                            :class="[
                                't-input',
                                errors?.destino_altura && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_altura"
                            placeholder="ej. 4864"
                        />
                        <small
                            v-if="errors?.destino_altura"
                            id="destino_altura-help"
                            class="p-error"
                        >
                            {{ errors.destino_altura[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label for="destino_piso" class="my-1 text-gray-700">
                            Piso
                        </label>
                        <input
                            type="text"
                            id="destino_piso"
                            :class="[
                                't-input',
                                errors?.destino_piso && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_piso"
                            placeholder="ej. 4"
                        />
                        <small
                            v-if="errors?.destino_piso"
                            id="destino_piso-help"
                            class="p-error"
                        >
                            {{ errors.destino_piso[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="destino_dpto" class="my-1 text-gray-700">
                            Dpto.
                        </label>
                        <input
                            type="text"
                            id="destino_dpto"
                            :class="[
                                't-input',
                                errors?.destino_dpto && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_dpto"
                            placeholder="ej. Centro"
                        />
                        <small
                            v-if="errors?.destino_dpto"
                            id="destino_dpto-help"
                            class="p-error"
                        >
                            {{ errors.destino_dpto[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label for="destino_cp" class="my-1 text-gray-700">
                            Código Postal<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="destino_cp"
                            :class="[
                                't-input',
                                errors?.destino_cp && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_cp"
                            placeholder="ej. 6000"
                        />
                        <small
                            v-if="errors?.destino_cp"
                            id="destino_cp-help"
                            class="p-error"
                        >
                            {{ errors.destino_cp[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label
                            for="destino_localidad"
                            class="my-1 text-gray-700"
                        >
                            Localidad<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="destino_localidad"
                            :class="[
                                't-input',
                                errors?.destino_localidad && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_localidad"
                            placeholder="ej. Junín"
                        />
                        <small
                            v-if="errors?.destino_localidad"
                            id="destino_localidad-help"
                            class="p-error"
                        >
                            {{ errors.destino_localidad[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label
                            for="destino_provincia"
                            class="my-1 text-gray-700"
                        >
                            Provincia<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="destino_provincia"
                            :class="[
                                't-input',
                                errors?.destino_provincia && 't-input-invalid',
                            ]"
                            v-model="destinatario.destino_provincia"
                            placeholder="ej. Buenos Aires"
                        />
                        <small
                            v-if="errors?.destino_provincia"
                            id="destino_provincia-help"
                            class="p-error"
                        >
                            {{ errors.destino_provincia[0] }}
                        </small>
                    </div>
                </div>

                <div class="w-full h-24">
                    <label for="destino_observacion" class="my-1 text-gray-700">
                        Observación
                    </label>
                    <input
                        type="text"
                        id="destino_observacion"
                        :class="[
                            't-input',
                            errors?.destino_observacion && 't-input-invalid',
                        ]"
                        v-model="destinatario.destino_observacion"
                    />
                    <small
                        v-if="errors?.destino_observacion"
                        id="destino_observacion-help"
                        class="p-error"
                    >
                        {{ errors.destino_observacion[0] }}
                    </small>
                </div>

                <div v-if="showAddToDir">
                    <div class="flex items-center mb-4">
                        <input
                            id="addtodir"
                            aria-describedby="multiple_etiqueta"
                            type="checkbox"
                            class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                            :checked="addNewToDirectory"
                            v-model="addToDir"
                            @change="$emit('updateAddNewToDirectory', addToDir)"
                        />
                        <label
                            for="addtodir"
                            class="ml-3 text-sm text-gray-700"
                            >Agregar a directorio
                        </label>
                    </div>
                </div>

                <div v-if="showUpdateDir">
                    <div class="flex items-center mb-4">
                        <input
                            id="updateDir"
                            aria-describedby="multiple_etiqueta"
                            type="checkbox"
                            class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                            :checked="updateExistingDirectory"
                            v-model="updateDir"
                            @change="$emit('updateExistingDirectoryValue', updateDir)"
                        />
                        <label
                            for="updateDir"
                            class="ml-3 text-sm text-gray-700"
                            >Guardar cambios
                        </label>
                    </div>
                </div>

                <div class="flex flex-col mb-4">
                    <div class="text-[12px] text-gray-600">
                        <span class="text-red-400">*</span>
                        <span>es requerido</span>
                    </div>
                </div>

            </div>
        </div>
    </XyzTransition>
</template>

<script>
export default {
    name: "DestinatarioForm",
    props: {
        errors: Object,
        destinatarios: Array,
        selectedDestination: Number,
        addNewToDirectory: Boolean,
        updateExistingDirectory: Boolean,
    },
    data() {
        return {
            selectedCountry: null,
            addToDir: false,
            udpateDir: false,
            showAddToDir: true,
            showUpdateDir: false,
            destinatario: {
                destino_nombre: null,
                destino_documento: null,
                destino_telefono: null,
                destino_email: null,
                destino_cp: null,
                destino_calle: null,
                destino_altura: null,
                destino_piso: null,
                destino_dpto: null,
                destino_localidad: null,
                destino_provincia: null,
                destino_observacion: null,
            },
        };
    },
    mounted() {
        // console.log(this.destinatarios);
    },
    watch: {
        destinatario: {
            deep: true,
            handler() {
                this.$emit("updateDestinatario", this.destinatario);
            },
        },
    },
    methods: {
        setDestination(e) {
            if (e.value) {
                this.$emit('changeSelectedDestination', e.value);
                this.showAddToDir = false;
                this.showUpdateDir = true;
                let destination = this.destinatarios.find(
                    (d) => d.id === e.value
                );
                this.destinatario.destino_nombre = destination.nombre;
                this.destinatario.destino_documento = destination.documento;
                this.destinatario.destino_telefono = destination.telefono;
                this.destinatario.destino_email = destination.email;
                this.destinatario.destino_cp = destination.cp;
                this.destinatario.destino_calle = destination.calle;
                this.destinatario.destino_altura = destination.altura;
                this.destinatario.destino_piso = destination.piso;
                this.destinatario.destino_dpto = destination.dpto;
                this.destinatario.destino_localidad = destination.localidad;
                this.destinatario.destino_provincia = destination.provincia;
                this.destinatario.destino_observacion = destination.observacion;
            } else {
                this.clearForm();
            }
        },
        clearForm() {
            this.$emit('changeSelectedDestination', null);
            this.showAddToDir = true;
            this.showUpdateDir = false;
            this.destinatario = {
                destino_nombre: null,
                destino_documento: null,
                destino_telefono: null,
                destino_email: null,
                destino_cp: null,
                destino_calle: null,
                destino_altura: null,
                destino_piso: null,
                destino_dpto: null,
                destino_localidad: null,
                destino_provincia: null,
                destino_observacion: null,
            };
        },
    },
};
</script>

<style scoped>
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number] {
    -moz-appearance: textfield;
}
</style>